module.exports = __webpack_public_path__ + "img/pro-p-slider6.9a5e2d3e.png";